module.exports = __webpack_public_path__ + "static/media/certificateofconformityfront.938cb80c.svg";